import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function coordinateValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'string' && value.trim() === '') {
      return { coordinate: { min, max } };
    }

    const coordinate = Number(value);
    return Number.isFinite(coordinate) && coordinate >= min && coordinate <= max
      ? null
      : { coordinate: { min, max } };
  };
}
